import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=eaaf4b72&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=js&"
export * from "./DetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=eaaf4b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaaf4b72",
  null
  
)

export default component.exports